import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CreateInventoryRequest from "components/modules/e-commerce/products/CreateInventoryRequest";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const InventoryRequestsPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  
  return (
    <Container fluid className="px-0 inventory-request-container">
      {/* Toast container for notifications */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={isRTL}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored" // Use colored theme for better dark mode compatibility
        toastClassName="inventory-toast" // Custom class for toast styling
      />
      
      <CreateInventoryRequest />
    </Container>
  );
};

export default InventoryRequestsPage;
